// removed by extract-text-webpack-plugin
module.exports = {"actions":"onfido-sdk-ui-Photo-actions","btn":"onfido-sdk-ui-Photo-btn"};


//////////////////
// WEBPACK FOOTER
// ./components/Photo/style.css
// module id = 381
// module chunks = 1